module.exports = __webpack_public_path__ + "static/img/sweepstakes.ca505dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/print/sweepstakes.png
// module id = DtHx
// module chunks = 1